import store from '@/store';
import axios from 'axios';
import Cookies from 'js-cookie';

store.subscribe((mutation) => {
  switch (mutation.type) {
    case 'auth/SET_TOKEN':
      if (mutation.payload !== null) {
        axios.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${mutation.payload}`;
        store.state.upload.options.headers.Authorization = `Bearer ${mutation.payload}`;
      } else {
        axios.defaults.headers.common['Authorization'] = null;
        store.state.upload.options.headers.Authorization = null;
        Cookies.remove('token');
      }

      break;
  }
});
